<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import BasicInfoInputCard from '../components/BasicInfoInputCard.vue';
import SimulationParametersCard from '../components/SimulationParametersCard.vue';
import EventListCard from '../components/EventListCard.vue';
import ResultsPanel from '../components/ResultsPanel.vue';
import HeroBanner from '../components/HeroBanner.vue';
import { NavPanel } from '@fire-calc/ui-vue';
import { useCalculatorStore } from '../state/calculatorStore';

const { t } = useI18n();
const store = useCalculatorStore();

const currentAge = computed(() => store.scenario.currentAge.value);
const currentAgeYear = computed(() => new Date().getFullYear());
</script>

<template>
  <div class="min-h-screen bg-bg-page">
    <div class="mx-auto max-w-content w-full p-lg">
      <NavPanel :title="t('appTitle')" />
      <div class="mt-xl"><HeroBanner /></div>
      <div class="mt-3xl grid grid-cols-1 lg:grid-cols-12 gap-xl">
        <div class="lg:col-span-7 flex flex-col gap-xl">
          <BasicInfoInputCard />
          <SimulationParametersCard />
          <EventListCard
            :events="store.scenario.events"
            :current-age="currentAge"
            :current-age-year="currentAgeYear"
            :store="store"
          />
        </div>
        <div class="lg:col-span-5">
          <ResultsPanel />
        </div>
      </div>
    </div>
  </div>
</template>
